var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.markerList),function(item,idx){return _c('div',{key:idx},[_c('CiteMarker',{attrs:{"item":item,"map":_vm.map}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }